import { CloseButton, CrudMode, ListContext, ListContextValue, Stack, newToast } from "@compass/core";
import { SubmitButton } from "components";
import {
  ApplicationResponseFile,
  FileTypeCategory,
  StudentFile,
  StudentServiceFile,
  UploadFile,
} from "generated/openApi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";
import { FileDetailTypeEnum } from "./FileDetailTypeEnum";
import { useContext } from "react";

export const FileDetailHeader = (props: {
  crudMode: CrudMode;
  entityId: Number;
  // parentEntityId: Number;
  fileType: FileTypeCategory;
  fetch?: (id: number) => void;
  reroute?: (id: number, crudMode: CrudMode) => void;
  applicationResponseFile: ApplicationResponseFile | undefined;
  studentFile: StudentFile | undefined;
  studentServiceFile: StudentServiceFile | undefined;
  onSave: (id: number) => void;
  onFileChange?: (uploadFile: StudentServiceFile | StudentFile | ApplicationResponseFile) => void;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listContext = useContext<ListContextValue>(ListContext);

  const save = () => {
    // There's probably a better way to do this, but right now if onFileChange exists, they want to create files (child entities) at the same time as the parent entities (think Service + Service Files)
    // So if onFilechange() exists, use the workflow to let it be a controlled component, if not, let the API do the work
    if (props.onFileChange) {
      if (props.fileType == FileTypeCategory.Application && props.applicationResponseFile) {
        props.onFileChange(props.applicationResponseFile);
      }
      else if (props.fileType == FileTypeCategory.StudentServiceFile && props.studentServiceFile) {
        props.onFileChange(props.studentServiceFile);
      }
      else if (props.fileType == FileTypeCategory.StudentFile && props.studentFile) {
        props.onFileChange(props.studentFile);
      }
    }
    else {
      // If onFileChange does not exist.. let the API do the work (ie the parent entity already exists)
      if (props.entityId == 0) {
        if (props.fileType == FileTypeCategory.Application && props.applicationResponseFile) {
          ApiService.studentApplications.saveCreateFile(props.applicationResponseFile)
            .then((applicationResponseFileId) => {
              // props.reroute(applicationResponseFileId, "view");
              // props.fetch(applicationResponseFileId);
              listContext.loadList?.();
              dispatch(setAppToast(newToast("success")));
            })
            .catch((ex) => {
              dispatch(setAppToast(newToast("error")));
            });
        }
        else if (props.fileType == FileTypeCategory.StudentServiceFile && props.studentServiceFile) {
          ApiService.studentServices.saveCreateStudentFile(props.studentServiceFile)
            .then((studentServiceFileId) => {
              // props.reroute(studentServiceFileId, "view");
              // props.fetch(studentServiceFileId);
              listContext.loadList?.();
              dispatch(setAppToast(newToast("success")));
            })
            .catch((ex) => {
              dispatch(setAppToast(newToast("error")));
            });
        }
        else if (props.fileType == FileTypeCategory.StudentFile && props.studentFile) {
          ApiService.studentFiles.saveCreate(props.studentFile)
            .then((studentFileId) => {
              // props.reroute(studentFileId, "view");
              // props.fetch(studentFileId);
              listContext.loadList?.();
              dispatch(setAppToast(newToast("success")));
            })
            .catch((ex) => {
              dispatch(setAppToast(newToast("error")));
            });
        }
      }
      else {
        if (props.fileType == FileTypeCategory.Application && props.applicationResponseFile) {
          ApiService.studentApplications.saveCreateFile(props.applicationResponseFile)
            .then((applicationResponseFileId) => {
              // props.reroute(applicationResponseFileId, "edit");
              // props.fetch(applicationResponseFileId);
              listContext.loadList?.();
              dispatch(setAppToast(newToast("success")));
            })
            .catch((ex) => {
              dispatch(setAppToast(newToast("error")));
            });
        }
        else if (props.fileType == FileTypeCategory.StudentServiceFile && props.studentServiceFile) {
          ApiService.studentServices.saveUpdateStudentFile(props.studentServiceFile)
            .then((studentServiceFileId) => {
              // props.reroute(studentServiceFileId, "edit");
              // props.fetch(studentServiceFileId);
              listContext.loadList?.();
              dispatch(setAppToast(newToast("success")));
            })
            .catch((ex) => {
              dispatch(setAppToast(newToast("error")));
            });
        }
        else if (props.fileType == FileTypeCategory.StudentFile && props.studentFile) {
          ApiService.studentFiles.saveUpdate(props.studentFile)
            .then((studentFileId) => {
              // props.reroute(studentFileId, "edit");
              // props.fetch(studentFileId);
              listContext.loadList?.();
              dispatch(setAppToast(newToast("success")));
            })
            .catch((ex) => {
              dispatch(setAppToast(newToast("error")));
            });
        }
      }
    }

  };

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center" spacing="sm">
        Upload File
      </Stack>

      <Stack direction="row" alignItems="center" spacing="sm">
        <CloseButton theme="Dark" />

        <SubmitButton
          theme="Dark"
          onClick={() => save()}
          disabled={(props.crudMode != "edit")}
        />
      </Stack>
    </Stack>
  );
};
